const matomoService = {
  send: (payload: Record<string, unknown>) => {
    if (!import.meta.client) return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  },
}

export default matomoService
